import React, { useMemo } from 'react';

import {
  CustomizeFeature,
  useCustomizeLandContext,
} from '@/features/customizeMyLand/provider';

import { NoteIds } from '../../config';
import LineSettings from './lineSettings';
import PointSettings from './pointSettings';
import ShapeSettings from './shapeSettings';
import TextSettings from './textSettings';

export type NewValues = {
  [key: string]: string | number | number[];
};

const CustomizeSettingsFormat = () => {
  const { activeFeature, drawTool, updateDrawFeature, updateCustomization } =
    useCustomizeLandContext();

  const isActivePointText = useMemo(
    () => activeFeature?.properties?.toolId === NoteIds.TEXT,
    [activeFeature?.properties?.toolId]
  );

  const handleValueChange = (newValues: NewValues) => {
    const updatedVal = { ...(activeFeature as CustomizeFeature) };
    if (updatedVal.properties) {
      const fields = Object.keys(newValues);

      if (activeFeature && typeof activeFeature?.id === 'string' && drawTool) {
        fields.forEach((field) => {
          drawTool?.setFeatureProperty(
            activeFeature?.id as string,
            field,
            newValues[field]
          );
          updatedVal.properties[field] = newValues[field];
        });
        updateCustomization(updatedVal);
        updateDrawFeature(updatedVal);
        const newFeat = drawTool?.get(String(activeFeature.id));
        if (newFeat) drawTool?.add(newFeat);
      }
    }
  };
  const SettingsMap = {
    Line: (
      <LineSettings
        activeFeature={activeFeature}
        handleValueChange={handleValueChange}
      />
    ),
    Point: isActivePointText ? (
      <TextSettings
        activeFeature={activeFeature}
        handleValueChange={handleValueChange}
      />
    ) : (
      <PointSettings
        activeFeature={activeFeature}
        handleValueChange={handleValueChange}
      />
    ),
    Polygon: (
      <ShapeSettings
        activeFeature={activeFeature}
        handleValueChange={handleValueChange}
      />
    ),
  };
  return (
    <div className="flex flex-col gap-4 p-2">
      {activeFeature &&
        activeFeature.geometry.type &&
        (SettingsMap[activeFeature.geometry.type] || SettingsMap.Line)}
    </div>
  );
};

export default CustomizeSettingsFormat;
